import { SalesInvoiceState } from '../../../common/application/model/enums/SalesInvoiceState';
import { PurchaseInvoiceState } from '../../../common/application/model/enums/PurchaseInvoiceState';
import { CustomerState } from '../../../common/application/model/enums/CustomerState';
import { VehicleState } from '../../../common/application/model/enums/VehicleState';

export function getTagTypeFromPurchaseInvoiceState(state: PurchaseInvoiceState): string {
    switch (state) {
        case PurchaseInvoiceState.OPEN:
        case PurchaseInvoiceState.OPEN_APPROVED:
        case PurchaseInvoiceState.OPEN_TARGETED:
            return 'is-info';
        case PurchaseInvoiceState.OPEN_ERROR:
            return 'is-danger';
        case PurchaseInvoiceState.REJECTED:
            return 'is-dark';
        case PurchaseInvoiceState.OPEN_APPROVAL:
            return 'is-warning';
        case PurchaseInvoiceState.OPEN_REJECTED:
            return 'is-black';
        case PurchaseInvoiceState.APPROVAL_EXTERNAL:
        case PurchaseInvoiceState.VERIFICATION_EXTERNAL:
            return 'is-light';
        case PurchaseInvoiceState.ACCEPTED:
            return 'is-success';
        default:
            return 'is-white';
    }
}

export function getTagTypeFromSalesInvoiceState(state: SalesInvoiceState): string {
    switch (state) {
        case SalesInvoiceState.DRAFT:
        case SalesInvoiceState.APPROVAL:
            return 'is-warning';
        case SalesInvoiceState.APPROVED:
            return 'is-info';
        case SalesInvoiceState.UNSENT:
            return 'is-light';
        case SalesInvoiceState.OPEN:
        case SalesInvoiceState.PAID:
            return 'is-success';
        case SalesInvoiceState.OVERDUE:
        case SalesInvoiceState.REMINDED:
        case SalesInvoiceState.REQUESTED:
        case SalesInvoiceState.COLLECTED:
            return 'is-dark';
        case SalesInvoiceState.CANCELED:
        case SalesInvoiceState.CREDIT_LOSS:
            return 'is-black';
        default:
            return 'is-white';
    }
}

export function getTagTypeFromCustomerState(state: CustomerState): string {
    switch (state) {
        case CustomerState.OPPORTUNITY:
            return 'is-info';
        case CustomerState.LEAD:
            return 'is-warning';
        case CustomerState.CONTACTED:
            return 'is-danger';
        case CustomerState.ACTIVE:
            return 'is-success';
        case CustomerState.INACTIVE:
            return 'is-black';

        default:
            return 'is-white';
    }
}

export function getTagTypeFromVehicleState(state: VehicleState): string {
    switch (state) {
        case VehicleState.DRAFT:
            return 'is-warning';
        case VehicleState.OFFER:
        case VehicleState.PENDING_APPROVAL:
            return 'is-danger';
        case VehicleState.ORDER:
        case VehicleState.HANDOVER_DONE:
            return 'is-info';
        case VehicleState.ACTIVE:
            return 'is-success';
        case VehicleState.REALIZATION:
        case VehicleState.SALE:
            return 'is-dark';
        case VehicleState.INACTIVE:
            return 'is-black';
        default:
            return 'is-white';
    }
}
